/**
 * @generated SignedSource<<1ead883d42bf402fac80dfa3cee84458>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMentionTriggerQuery$variables = {
  id: string;
};
export type useMentionTriggerQuery$data = {
  readonly chatChannel: {
    readonly chatChannelMembers?: {
      readonly totalCount: number;
    };
  } | null;
};
export type useMentionTriggerQuery = {
  response: useMentionTriggerQuery$data;
  variables: useMentionTriggerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatChannelMemberNodeConnection",
      "kind": "LinkedField",
      "name": "chatChannelMembers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMentionTriggerQuery",
    "selections": [
      {
        "alias": "chatChannel",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMentionTriggerQuery",
    "selections": [
      {
        "alias": "chatChannel",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d1da12a599b97261f6efc440fe2c7d4",
    "id": null,
    "metadata": {},
    "name": "useMentionTriggerQuery",
    "operationKind": "query",
    "text": "query useMentionTriggerQuery(\n  $id: ID!\n) {\n  chatChannel: node(id: $id) {\n    __typename\n    ... on ChatChannel {\n      chatChannelMembers {\n        totalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d41e28f30960a3d40ff875cb2567cfa";

export default node;
